export default __webpack_public_path__ + "static/media/m_monografia.cc12fd8b.png";